var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgJcb = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 32,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 48,
  height: 32,
  fill: "#fff",
  rx: 4
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#40A648",
  d: "M32.1 18.57h2.59a1 1 0 0 0 .81-1 1.07 1.07 0 0 0-.81-1 1.2 1.2 0 0 0-.28 0H32.1z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#40A648",
  d: "M34.14 4a4 4 0 0 0-4 4v4.15h5.65q.2-.024.4 0c1.27.06 2.22.72 2.22 1.86a1.88 1.88 0 0 1-1.83 1.83c1.3.09 2.29.81 2.29 1.94s-1.1 2-2.55 2h-6.2V28H36a4 4 0 0 0 4-4V4z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#40A648",
  d: "M35.22 14.31a.94.94 0 0 0-.81-1H32.1v1.93h2.09a.93.93 0 0 0 1.03-.94z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#0D67B0",
  d: "M12 4a4 4 0 0 0-4 4v9.87a7.9 7.9 0 0 0 3.45.9 1.92 1.92 0 0 0 2.14-2v-4.64H17v4.64c0 1.8-1.12 3.27-4.92 3.27a17 17 0 0 1-4.08-.5V28h5.87a4 4 0 0 0 4-4V4z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#BE2034",
  d: "M23.09 4a4 4 0 0 0-4 4v5.23c1-.86 2.77-1.41 5.6-1.27 1.06.063 2.11.224 3.14.48v1.69a7.6 7.6 0 0 0-3-.88c-2.15-.15-3.45.9-3.45 2.75s1.3 2.92 3.45 2.75a8.1 8.1 0 0 0 3-.88v1.69c-1.03.258-2.08.419-3.14.48-2.83.14-4.59-.41-5.6-1.27V28H25a4 4 0 0 0 4-4V4z"
})));
export default SvgJcb;